<script setup>
// BonBoZ: ô chọn dạng dropdown — dùng chung cho mọi bộ lọc trong thanh hội thoại.
//
// Tồn tại vì thẻ `<select>` thô của trình duyệt không nhận style: nó vẽ mũi tên
// và bảng chọn theo hệ điều hành, nên đứng cạnh nút khác là lạc hẳn.
//
// `hienAvatar` bắt buộc khai ở nơi gọi: trang có avatar, nhóm thì không.
// và các form cần chọn trang (tạo tag hàng loạt...).
//
// Phải tự dựng listbox vì <option> của select gốc không nhét được ảnh.
// Không giữ trạng thái nào ngoài việc đóng/mở: giá trị đi qua v-model, cha
// quyết định làm gì khi đổi (điều hướng, lưu form...).
import { computed, ref } from 'vue';
import Avatar from 'dashboard/components-next/avatar/Avatar.vue';

const props = defineProps({
  muc: { type: Array, required: true },
  // icon hien khi chua chon gi, va o dong "tat ca"
  icon: { type: String, default: 'i-lucide-layout-grid' },
  // trang co avatar; nhom thi khong - bat buoc khai o noi goi cho ro
  hienAvatar: { type: Boolean, default: false },
  // '' = mục "tất cả trang" / "không gắn"
  modelValue: { type: [String, Number], default: '' },
  allLabel: { type: String, required: true },
  // compact: cỡ ô lọc trong thanh danh sách hội thoại (h-7, chữ xs)
  compact: { type: Boolean, default: false },
});
const emit = defineEmits(['update:modelValue']);

const mo = ref(false);

const dangChon = computed(
  () => props.muc.find(h => String(h.id) === String(props.modelValue)) || null
);

const chon = hop => {
  emit('update:modelValue', hop ? hop.id : '');
  mo.value = false;
};

const lopNut = computed(() =>
  props.compact
    ? '!h-8 !m-0 !px-2 !py-0 !text-sm !rounded-md'
    : '!m-0 !px-2 !py-1.5 !text-sm !rounded-md border border-n-weak'
);
</script>

<template>
  <div class="relative min-w-0 flex-1">
    <button
      type="button"
      class="flex w-full items-center gap-1.5 !bg-n-alpha-1 text-n-slate-12 hover:!bg-n-alpha-2 focus:outline-none focus-visible:ring-2 focus-visible:ring-n-brand"
      :class="lopNut"
      :aria-expanded="mo"
      @click="mo = !mo"
      @keydown.esc="mo = false"
    >
      <Avatar
        v-if="dangChon && hienAvatar"
        :src="dangChon.avatar_url"
        :name="dangChon.name"
        :size="compact ? 20 : 24"
        rounded-full
      />
      <i v-else :class="icon" class="size-4 shrink-0 text-n-slate-10" />
      <span class="min-w-0 flex-1 truncate text-left">
        {{ dangChon?.name || allLabel }}
      </span>
      <i class="i-lucide-chevron-down size-4 shrink-0 text-n-slate-10" />
    </button>

    <!-- tấm hứng bấm-ra-ngoài; nằm dưới danh sách (z-40 < z-50) -->
    <div v-if="mo" class="fixed inset-0 z-40" @click="mo = false" />
    <ul
      v-if="mo"
      class="absolute z-50 mt-1 max-h-56 w-full min-w-40 list-none overflow-y-auto rounded-md border border-n-weak bg-n-solid-2 p-1 shadow-lg"
    >
      <li>
        <button
          type="button"
          class="flex w-full items-center gap-1.5 !rounded !bg-transparent !px-2 !py-1.5 !text-sm text-left text-n-slate-11 hover:!bg-n-alpha-1"
          @click="chon(null)"
        >
          <i :class="icon" class="size-4 shrink-0" />
          <span class="min-w-0 flex-1 truncate">{{ allLabel }}</span>
        </button>
      </li>
      <li v-for="hop in muc" :key="hop.id">
        <button
          type="button"
          class="flex w-full items-center gap-1.5 !rounded !bg-transparent !px-2 !py-1.5 !text-sm text-left text-n-slate-12 hover:!bg-n-alpha-1"
          @click="chon(hop)"
        >
          <Avatar
            v-if="hienAvatar"
            :src="hop.avatar_url"
            :name="hop.name"
            :size="compact ? 20 : 24"
            rounded-full
          />
          <span class="min-w-0 flex-1 truncate">{{ hop.name }}</span>
        </button>
      </li>
    </ul>
  </div>
</template>
